import React from 'react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { COLLECTION_LAYOUT_LIST } from '../../utils/constans/collectionLayoutSelectorList';

const Icons = styled('span')(({ theme }) => ({
    position: 'relative',
    cursor: ' pointer',
    display: 'inline-block',
    verticalAlign: 'middle',
    width: '26px',
    height: '26px',
    padding: '3px',
    border: '1px solid grey',
    marginLeft: '5px',
    '&:before': {
        content: '""',
        position: 'absolute',
        top: '3px',
        left: '3px',
        backgroundColor: 'grey',
    },
    '&.icon-mode-list': {
        '&:before': {
            boxShadow: ' 0 7px 0 grey,0 14px 0 grey',
            width: '18px',
            height: '4px',
        },
        '&.selected': {
            '&:before': {
                boxShadow: ' 0 7px 0 black,0 14px 0 black',
                backgroundColor: 'black',
            },
        },
    },
    '&.icon-mode-grid': {
        ':before': {
            width: '4px',
            height: '18px',
        },
        '&.grid-2': {
            width: '19px',
            ':before': {
                boxShadow: ' 7px 0 0 grey',
            },
        },
        '&.grid-3': {
            width: '26px',
            ':before': {
                boxShadow: '7px 0 0 grey,14px 0 0 grey',
            },
        },
        '&.grid-4': {
            width: '33px',
            ':before': {
                boxShadow: '7px 0 0 grey,14px 0 0 grey,21px 0 0 grey',
            },
        },
        '&.grid-5': {
            width: '40px',
            ':before': {
                boxShadow:
                    '7px 0 0 grey,14px 0 0 grey,21px 0 0 grey,28px 0 0 grey',
            },
        },
        '&.selected': {
            ':before': {
                backgroundColor: 'black',
            },
            '&.grid-2': {
                ':before': {
                    boxShadow: ' 7px 0 0 black',
                },
            },
            '&.grid-3': {
                ':before': {
                    boxShadow: '7px 0 0 black,14px 0 0 black',
                },
            },
            '&.grid-4': {
                ':before': {
                    boxShadow: '7px 0 0 black,14px 0 0 black,21px 0 0 black',
                },
            },
            '&.grid-5': {
                ':before': {
                    boxShadow:
                        '7px 0 0 black,14px 0 0 black,21px 0 0 black,28px 0 0 black',
                },
            },
        },
    },
}));

export const CollectionItemsViewSelector: React.FC<ListViewProps> = (props) => {
    const { t } = useTranslation('collection');
    const { selectedLayout, handleSelectLayout } = props;
    const handleLayoutChange = (id) => {
        handleSelectLayout(id);
    };

    return (
        <Box>
            {t('COLLECTIONS.SHOW_AS').toUpperCase()}
            {COLLECTION_LAYOUT_LIST.map((item) => (
                <Icons
                    key={item.id}
                    className={
                        item.className +
                        (selectedLayout == item.id ? ' selected' : '')
                    }
                    role="button"
                    aria-label={item.ariaLabel}
                    onClick={() => handleLayoutChange(item.id)}
                ></Icons>
            ))}
        </Box>
    );
};

type ListViewProps = {
    selectedLayout: string;
    handleSelectLayout: (id: string) => void;
};
